import { useGetChangelogQuery } from "graphql/queries/get-changelog.generated";
import { Link } from "react-router-dom";

const Changelog: React.FC = () => {
  const { data: changelogData } = useGetChangelogQuery();

  if (!changelogData || changelogData.changelog.length === 0) {
    return null;
  }

  return (
    <div className="changelog-container">
      <div className="changelog-inner-container">
        <div className="changelog-header">
          What's New
          <Link to="https://www.highnotes.com/releases/current" target="_blank" rel="noopener">
            <img src={`${process.env.PUBLIC_URL}/assets/images/icons/external-link-grey.svg`} />
          </Link>
        </div>
        <ul className="changelog-messages">
          {changelogData.changelog.map(change => (
            <li key={change.id} className="changelog-message">
              <span className="changelog-description">{change.description}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Changelog;